import React, { useEffect, useMemo, useState } from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import {
  formatHandlingElapsed,
  getHandlingElapsedMs,
  isHandlingTimerTerminal,
} from "../operationRequestHandlingTimer.js";
import "./OperationRequestHandlingTimer.scss";

/**
 * Live handling timer for an ops conversation (from createdAt until terminal status).
 */
export default function OperationRequestHandlingTimer({
  request,
  className = "",
  compact = false,
}) {
  const startedAt =
    request?.createdAt || request?.created_at || request?.handlingStartedAt || null;
  const terminal = isHandlingTimerTerminal(request?.status || request?.effectiveStatus);
  const endedAt = terminal
    ? request?.updatedAt || request?.updated_at || null
    : null;

  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (terminal || !startedAt) return undefined;
    const id = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [terminal, startedAt]);

  const elapsedMs = useMemo(
    () =>
      getHandlingElapsedMs({
        startedAt,
        endedAt,
        nowMs: terminal ? undefined : nowMs,
        terminal,
      }),
    [startedAt, endedAt, nowMs, terminal]
  );

  if (!startedAt || elapsedMs == null) return null;

  const label = formatHandlingElapsed(elapsedMs);
  const tone =
    terminal
      ? "done"
      : elapsedMs >= 4 * 60 * 60 * 1000
        ? "late"
        : elapsedMs >= 60 * 60 * 1000
          ? "warn"
          : "ok";

  return (
    <span
      className={`ops-handling-timer ops-handling-timer--${tone}${compact ? " ops-handling-timer--compact" : ""}${className ? ` ${className}` : ""}`}
      title={terminal ? "זמן טיפול עד סגירה" : "זמן טיפול פתוח"}
      aria-label={terminal ? `זמן טיפול: ${label}` : `זמן טיפול פתוח: ${label}`}
    >
      <ClockCircleOutlined aria-hidden />
      <span className="ops-handling-timer__label">
        {compact ? label : `זמן טיפול: ${label}`}
      </span>
    </span>
  );
}
